module.exports = __webpack_public_path__ + "img/airklima-icons.78a58249.png";